import { env } from '@src/env';

const SpinnerComponent = () => {
  const flavor = env.VITE_FLAVOR ? env.VITE_FLAVOR : 'default/';
  const base = env.VITE_PUBLIC_PATH || '/';
  const logo = `${base}assets/${flavor}logo.png`;

  return (
    <div className="fallback-spinner vh-100">
      <img className="fallback-logo" src={logo} alt="logo" />
      <div className="loading">
        <div className="effect-1 effects"></div>
        <div className="effect-2 effects"></div>
        <div className="effect-3 effects"></div>
      </div>
    </div>
  );
};

export default SpinnerComponent;
